<template>
  <AppProvider><RootComponent/></AppProvider>
      
</template>

<script>
import RootComponent from './components/RootComponent.vue'
import {AppProvider} from '@ownego/polaris-vue';
export default {
  name: 'App',
  components: {
    RootComponent,
    AppProvider
}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
